<template>
  <div>
    <table :key="type" id="datatable" class="stripe hover">
      <thead>
        <tr>
          <th>วันที่ทำรายการ</th>
          <th>รหัสการลงทะเบียน</th>
          <th>เลขที่ผู้เสียภาษี</th>
          <th>Domain</th>
          <th>ชื่อ</th>
          <th>นามสกุล</th>
          <th>สถานะ</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody></tbody>
      <tfoot>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  props: ["statuses", "type"],

  mounted() {
    let parent = this;
    let type = this.type;
    $("#datatable").DataTable({
      dom: "tpr",
      pageLength: 50,
      processing: true,
      serverSide: true,
      order: [[0, "desc"]],
      ajax: "/staff/registrations/datatable?type=" + type,
      columns: [
        { data: "created_at", name: "created_at" },
        { data: "reference", name: "reference" },
        { data: "tax_id", name: "tax_id" },
        { data: "domain", name: "domain" },
        { data: "owner_firstname", name: "owner_firstname" },
        { data: "owner_lastname", name: "owner_lastname" },
        { data: "status", name: "status" },
        {
          data: "id",
          name: "id",
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            let btn = `<button type="button" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded documentBtn" data-id="${data}"><i class="fa fa-edit"></i> แสดง</button>`;
            return btn;
          },
        },
      ],
      initComplete: function () {
        //setup datatable when all data ready
        this.api()
          .columns([0, 1, 2, 3, 4, 5, 6])
          .every(function (i) {
            let column = this;
            let input = null;

            input = $(document.createElement("input"));

            if (i === 6) {
              input = $(document.createElement("select"));
              let status = null;
              input.append('<option value="">ทั้งหมด</option>');
              for (status of parent.statuses) {
                let option = document.createElement("option");
                $(option).attr("value", status.value).append(status.name);
                input.append(option);
              }
            } else input = $(document.createElement("input"));

            input
              .addClass(
                "border border-gray-300 p-2 my-2 rounded-md focus:outline-none focus:ring-2 ring-blue-200 w-full"
              )
              .appendTo($(column.footer()).empty())
              .on("change", function () {
                column.search($(this).val(), false, false, true).draw();
              });
          });
        this.find("tfoot tr").appendTo(this.find("thead"));
      },
      drawCallback: function (settings) {
        $(".documentBtn").click(function () {
          let editRoute = route("staff.registrations.edit", {
            registration: $(this).data("id"),
          });
          parent.$inertia.get(editRoute);
        });
      },
    });
  },
};
</script>
